import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import BatchExecutionDetailsModal from './BatchExecutionDetailsModal';
import {
  isLoading as isLoadingSelector,
  queries as queriesSelector,
  filename as filenameSelector,
  context as contextSelector,
  options as optionsSelector,
  detailsList as detailsListSelector,
  isShowPictures as isShowPicturesSelector,
} from './BatchExecutionDetailsModalSelectors';

import BatchExecutionDetailsModalReducer from './BatchExecutionDetailsModalReducer';
import { batchExecutionDetailsModalReducerKey } from './BatchExecutionDetailsModalConstants';
import { init, openQuery, cancel } from './BatchExecutionDetailsModalActions';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  queries: queriesSelector(state),
  filename: filenameSelector(state),
  context: contextSelector(state),
  options: optionsSelector(state),
  detailsList: detailsListSelector(state),
  isShowPictures: isShowPicturesSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init(ownProps.searchId, ownProps.databaseId)),
  openQuery: (detail) => dispatch(openQuery(ownProps.databaseId, detail)),
  cancel: () => dispatch(cancel(ownProps.closeCallback)),
});

export default compose(
  withReducer(batchExecutionDetailsModalReducerKey, BatchExecutionDetailsModalReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(BatchExecutionDetailsModal);
